import { render, staticRenderFns } from "./TransferDetailItem.vue?vue&type=template&id=40a3e0ad&scoped=true"
import script from "./TransferDetailItem.vue?vue&type=script&lang=js"
export * from "./TransferDetailItem.vue?vue&type=script&lang=js"
import style0 from "./TransferDetailItem.vue?vue&type=style&index=0&id=40a3e0ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3e0ad",
  null
  
)

export default component.exports